import React, { useEffect } from 'react';
import { X } from 'lucide-react';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: LegalModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-47">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-[#4A2C40]/60 backdrop-blur-sm" onClick={onClose} aria-hidden="true" data-id="element-48" />

      {/* Modal */}
      <div className="relative bg-[#FDFBF7] rounded-2xl shadow-2xl w-full max-w-2xl max-h-[80vh] flex flex-col" role="dialog" aria-modal="true" aria-label={title} data-id="element-49">
        {/* Header */}
        <div className="flex items-center justify-between px-8 py-6 border-b border-[#4A2C40]/10" data-id="element-50">
          <h2 className="text-2xl font-serif font-bold text-[#4A2C40]" data-id="element-51">
            {title}
          </h2>
          <button onClick={onClose} className="p-2 rounded-lg text-[#4A2C40]/60 hover:text-[#4A2C40] hover:bg-[#F3EFE7] transition-colors" aria-label="Close" data-id="element-52">
            <X className="h-5 w-5" data-id="element-53" />
          </button>
        </div>

        {/* Content */}
        <div className="px-8 py-6 overflow-y-auto text-[#4A2C40]/80 text-sm leading-relaxed space-y-4" data-id="element-54">
          {children}
        </div>
      </div>
    </div>;
}